import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import { useMyApprovers } from "../../approvers/useMyApprovers";
import ui from "../../../components/ui/ui.module.css";

const SOURCE_LABELS = {
  EMPLOYEE: "Set for you",
  RULE: "Company rule",
};

// Who approves each kind of request, level by level (GET /approvers/me → byType).
// Any one approver listed on a level can approve that level.
const MyApproversCard = () => {
  const query = useMyApprovers();
  const routes = query.data?.byType ?? [];

  return (
    <div className={cx(ui.card, ui.cardPadded)}>
      <div className={cx(ui.cardTitle, "mb-2")}>
        <i className="bi bi-person-check me-2"></i>
        My approvers
      </div>

      {query.isLoading ? (
        <span className={ui.muted}>Loading…</span>
      ) : query.isError ? (
        <span className={ui.muted}>Couldn't load your approvers.</span>
      ) : routes.length === 0 ? (
        <span>Your branch manager / HR</span>
      ) : (
        <div className="row g-3">
          {routes.map((route) => {
            const isDefault =
              route.source === "DEFAULT" || !route.levels?.length;
            return (
              <div key={route.requestType} className="col-12 col-md-6">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <strong>{route.label}</strong>
                  {!isDefault && SOURCE_LABELS[route.source] && (
                    <Badge tone="gray">{SOURCE_LABELS[route.source]}</Badge>
                  )}
                </div>
                {isDefault ? (
                  <span className={ui.muted}>Branch manager / HR</span>
                ) : (
                  <ol className="mb-0 ps-3 small">
                    {route.levels.map((level) => (
                      <li key={level.level}>
                        Level {level.level}:{" "}
                        {level.approvers.map((a) => a.name).join(", ")}
                        {level.approvers.length > 1 && (
                          <span className={ui.muted}> (any one of them)</span>
                        )}
                      </li>
                    ))}
                  </ol>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyApproversCard;
